<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
  <div class="w-full bg-white flex-column">
    <div class="h-50 w-full  flex a-center" style="background-color: #F7F9FD">
      <Button @click="editAccount" class="m-l-20">编辑</Button>
      <div class="bold fs-18 color-33  absolute flex-column left-100 right-100">企业信息</div>
    </div>

    <div class="flex j-center a-center" style="width: 500px;margin-top: 40px">
      <div class="flex-1">logo：</div>
      <up-load-image :canclick="!disabled" @uploadSuccess="uploadLogoSuccess($event)" accept="image/*"
                     picurl="company/logo/" style="width: 64px;height:64px;">
        <template v-slot:tip>
          <img src="../../assets/common/ic_default_img.png" style="width: 64px;height: 64px;cursor: pointer"
               v-if="!entInfo.logo">
          <img :src="entInfo.logo" style="width: 64px;height: 64px;cursor: pointer"
               v-if="entInfo.logo">
        </template>
      </up-load-image>
    </div>

    <div class="m-v-10 h-1" style="background-color: #d8d8d8;width: 500px"></div>

    <div class="flex h-40" style="width: 500px;">
      <div class="flex-column">单位名称：</div>
      <input :disabled='disabled' class="flex-1" style="text-align: right"
             v-model="entInfo.entName"/>
    </div>
    <div class="m-v-10 h-1" style="background-color: #d8d8d8;width: 500px"></div>


    <!--<div class="flex h-40" style="width: 500px;">-->
    <!--<div class="flex-column">联系人：</div>-->
    <!--<input :disabled='disabled' class="flex-1" placeholder="联系人" style="text-align: right" v-model="entInfo.contact"/>-->
    <!--</div>-->
    <!--<div class="m-v-10 h-1" style="background-color: #d8d8d8;width: 500px"></div>-->

    <!--<div class="flex h-40" style="width: 500px;">-->
    <!--<div class="flex-column">联系电话：</div>-->
    <!--<input :disabled='disabled' class="flex-1" placeholder="联系电话" style="text-align: right" v-model="entInfo.phone"/>-->
    <!--</div>-->
    <!--<div class="m-v-10 h-1" style="background-color: #d8d8d8;width: 500px"></div>-->

    <!--<div class="flex h-40" style="width: 500px;">-->
    <!--<div class="flex-column">超级管理员：</div>-->
    <!--<input :disabled='disabled' class="flex-1" placeholder="超级管理员" style="text-align: right"-->
    <!--v-model="entInfo.superName"/>-->
    <!--</div>-->
    <!--<div class="m-v-10 h-1" style="background-color: #d8d8d8;width: 500px"></div>-->


    <!--<div class="flex h-40" style="width: 500px;">-->
    <!--<div class="flex-column">网址：</div>-->
    <!--<input :disabled='disabled' class="flex-1" placeholder="网址" style="text-align: right" v-model="entInfo.webPage"/>-->
    <!--</div>-->
    <!--<div class="m-t-10 h-1" style="background-color: #d8d8d8;width: 500px"></div>-->

    <div class="w-full m-v-40 flex j-center">
      <Button @click="onCancelClick" style="width: 100px">取消</Button>
      <Button @click="onOkClick " class="m-l-20" style="width: 100px" type="primary" v-if="!disabled">
        保存
      </Button>
    </div>
  </div>
</template>

<script>
import UpLoadImage from './UpLoadImage'
import {mapActions} from 'vuex'

export default {
  name: 'EntEditWidget',
  components: {UpLoadImage},
  props: {
    entInfo: {
      type: Object,
      default: () => {
        return {
          logo: '',
          entName: '',
          contact: '',
          phone: '',
          superName: '',
          webPage: ''
        }
      }
    }
  },
  data () {
    return {
      disabled: true,
    }
  },
  mounted () {
    this.init()
  },
  methods: {
    init () {

    },
    editAccount () {
      this.disabled = false
    },
    uploadLogoSuccess (data) {
      if (data && data.length) {
        this.entInfo.logo = data[0].url
      }
    },
    onCancelClick () {
      this.$emit('cancel')
    },
    onOkClick () {
      if (!this.entInfo.entName) {
        return this.$Message.info('请输入公司名称')
      }
      let params = {
        name: this.entInfo.entName || '',
        logo: this.entInfo.logo || '',
      }
      this.editCurrentEntInfo(params).then(res => {
        if (res.code === 0) {
          this.$emit('ok')
        } else {
          if (res.msg) {
            this.$Message.info(res.msg)
          }
        }
      })
    },
    ...mapActions([
      'editCurrentEntInfo'
    ])
  }
}
</script>

<style lang="scss" scoped>

</style>
